import React from "react";
import { XCircleIcon, CheckCircle2Icon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { CTAButton } from "../CTAButton";
import { beforeItems, afterItems } from "../../data/sections";
export function BeforeAfterSection() {
  return <section className="bg-cream px-5 py-16 sm:py-24" data-id="element-93" data-mp="3fek9buvr0jl4">
      <SectionHeading title={<>
            From scattered information… to an <em className="text-brand" data-id="element-95" data-mp="6zs85wpgugrl">organized practice session</em>
          </>} subtitle="A visual system you can return to whenever you want to practice." data-id="element-94" data-mp="3ffbx4jj3td0u" />

      <div className="mx-auto mt-12 grid max-w-5xl gap-5 md:grid-cols-2" data-id="element-96" data-mp="3tf3g6yoh9jlp">
        <div className="rounded-3xl bg-coral-light p-6 ring-1 ring-coral/20 sm:p-8" data-id="element-97" data-mp="280l3w5iqt67">
          <p className="text-sm font-extrabold uppercase tracking-wider text-coral-dark" data-id="element-98" data-mp="25nyh5otfumt">Before</p>
          <h3 className="mt-1 font-serif text-2xl font-bold text-ink" data-id="element-99" data-mp="pvrxt0uz1880">Without the Blueprint</h3>
          <ul className="mt-6 space-y-4" data-id="element-100" data-mp="uq607n81wfm6">
            {beforeItems.map(item => <li key={item} className="flex gap-3 text-[17px] leading-snug text-ink/85" data-id="element-101" data-mp="22oe1kpsyhuqv">
                <XCircleIcon className="mt-0.5 h-6 w-6 shrink-0 text-coral" aria-hidden="true" data-id="element-102" data-mp="1xqukli4vj3v8" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="rounded-3xl bg-brand p-6 sm:p-8" data-id="element-103" data-mp="27mfh50r6bbxl">
          <p className="text-sm font-extrabold uppercase tracking-wider text-[#9FD3B8]" data-id="element-104" data-mp="2lec46qdzivn4">After</p>
          <h3 className="mt-1 font-serif text-2xl font-bold text-cream" data-id="element-105" data-mp="2gfrg1pc0c2f1">With Reflexology Session Blueprint™</h3>
          <ul className="mt-6 space-y-4" data-id="element-106" data-mp="2vdbgqk1vfbfe">
            {afterItems.map(item => <li key={item} className="flex gap-3 text-[17px] leading-snug text-cream" data-id="element-107" data-mp="2qdp0e1qqxf2d">
                <CheckCircle2Icon className="mt-0.5 h-6 w-6 shrink-0 text-[#9FD3B8]" aria-hidden="true" data-id="element-108" data-mp="10yqzkhcrdy0r" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>

      <p className="mx-auto mt-12 max-w-2xl text-center text-lg leading-relaxed text-ink/80" data-id="element-109" data-mp="1lnt8vr36l24z">
        Instead of asking yourself <em className="font-serif text-xl font-bold text-ink" data-id="element-110" data-mp="1povbmhwb3wbp">“What do I do now?”</em> you have a visual system to help guide your next step.
      </p>

      <CTAButton label="Yes! I want to organize my practice" className="mt-10" data-id="element-111" data-mp="1un6koqes22sv" />
    </section>;
}